// extracted by mini-css-extract-plugin
var _1 = "Banner-module_container___rw3L";
var _2 = "Banner-module_desktop__s1nTN";
var _3 = "Banner-module_mobile__DEeBP";
var _4 = "Banner-module_text__YUrQF";
export { _1 as "container", _2 as "desktop", _3 as "mobile", _4 as "text" }
export default { "container": _1, "desktop": _2, "mobile": _3, "text": _4 }
